import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import lexofficeService from '@/services/lexoffice.service';
import { useTranslation } from 'react-i18next';

// Ticket siparişinde Lexoffice faturasını bul + PDF aç (yeni sekme)
const LexInvoiceButton: React.FC<{ email?: string; orderNumber?: string; amount?: string }> = ({ email, orderNumber, amount }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  // Lexoffice yalnızca BAĞLIYSA (org'da api_key varsa) buton görünür. Aktifleştirmeyen org'larda gizli.
  // react-query aynı queryKey ile tüm butonlar için TEK fetch yapar; hata/bağlı-değil → gizli.
  const { data: lexCfg } = useQuery({
    queryKey: ['lexoffice-config'],
    queryFn: () => lexofficeService.getConfig(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  if (!lexCfg?.connected) return null;
  const open = async () => {
    // Pencereyi TIKLAMA ANINDA senkron aç (popup blocker'ı aşmak için) → PDF gelince oraya yönlendir
    const win = window.open('', '_blank');
    setBusy(true);
    try {
      const inv = await lexofficeService.findInvoice({ email, orderNumber, amount });
      if (inv?.found && inv.id) {
        toast.success(`Rechnung ${inv.voucherNumber || ''}`);
        await lexofficeService.openInvoicePdf(inv.id, win);
      } else {
        if (win && !win.closed) win.close();
        toast.error(inv?.error || 'Keine Rechnung gefunden');
      }
    } catch { if (win && !win.closed) win.close(); toast.error(t('common:x2.invoiceLoadFailed', 'Rechnung konnte nicht geladen werden')); }
    finally { setBusy(false); }
  };
  return (
    <button
      onClick={(e) => { e.stopPropagation(); open(); }}
      disabled={busy}
      className="inline-flex items-center gap-1 rounded-md border border-[#0086b3]/30 bg-[#0086b3]/[0.06] px-2 py-0.5 text-[10px] font-semibold text-[#0086b3] hover:bg-[#0086b3]/10 disabled:opacity-50"
      title={t('common:x2.showLexofficeInvoice', 'Rechnung aus Lexoffice anzeigen')}
    >
      {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileText className="h-3 w-3" />}
      Rechnung
    </button>
  );
};

export default LexInvoiceButton;
